/**
 * @module components\ghInput\rangeInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class RangeInput extends InputBase {
  private range: IRange = {};

  @Watch("value")
  private observeValue() {
    if (this.value) {
      if (this.value instanceof Object) {
        this.range = this.value;
        return;
      }
    }
    this.value = {};
    this.range = this.value;
  }

  mounted() {
    this.observeValue();
  }

  private get lowSymbol() {
    if (this.range) {
      if (this.range.includeLower) {
        return "[";
      }
    }
    return "(";
  }

  private set lowSymbol(val: string) {
    let flag = false;
    if (val === "[") {
      flag = true;
    }
    this.$set(this.range, "includeLower", flag);
  }

  private get upperSymbol() {
    if (this.range) {
      if (this.range.includeUpper) {
        return "]";
      }
    }
    return ")";
  }

  private set upperSymbol(val: string) {
    let flag = val === "]" ? true : false;
    this.$set(this.range, "includeUpper", flag);
  }

  private rangeSymbol = "~";
}
